import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  LOGIN_ERROR,
  CONNECT_AS_CLIENT,
  LOGOUT_AS_CLIENT
} from '../constants/auth';

export default (state = {}, action) => {
  switch (action.type) {
    case CONNECT_AS_CLIENT:
      return {
        ...state,
        clientToken: action.payload
      };
    case LOGOUT_AS_CLIENT:
      const { clientToken, ...rest } = state;
      return {
        ...rest
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        error: false
      };

    case LOGIN_ERROR:
      return {
        ...state,
        isAuthenticated: false,
        error: true
      };
    case LOGOUT_SUCCESS:
      return {
        isAuthenticated: false,
        token: null
      };
    default:
      return state;
  }
};
